module.exports = {
  messages: {
    CN: {
      my_collection: {
        title: '我的收藏',
        no_collection: '暂无收藏商品',
        reward_points: '{num}倍积分',
        productStockStatus: '库存紧张',
        disposals: '特卖品',
        full_minus: '满减',
        full_discount_coupon: '满折券',
        full_coupon_reduction: '满减券',
        parcel_post_voucher: '包邮券',
        replenishment: '补货中',
        to_end: '已经到底了',
        success: '加入购物车成功!',
        fail: '加入购物车失败!',
        del_success: '取消成功!'
      }
    }
  }
};